import { Component } from '@angular/core';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-semantics-ranking-top-topics',
  templateUrl: './semantics-ranking-top-topics.component.html',
  styleUrl: './semantics-ranking-top-topics.component.scss',
})
export class SemanticsRankingTopTopicsComponent {
  isLoading = true;

  constructor(protected analyticsService: AnalyticsService) {
    this.analyticsService.semanticsRankingTopicsCanonicals$.subscribe(
      (data) => {}
    );
    this.analyticsService.isLoading$.subscribe((loading) => {
      this.isLoading = loading.includes('semanticsRankingTopicsCanonicals');
    });

    this.getChartData();
  }

  getChartData() {
    this.analyticsService.getSemanticsRankingTopicsCanonicals().subscribe();
  }

  get data() {
    return (
      this.analyticsService.semanticsRankingTopicsCanonicals$.value?.top_topics
        ?.slice(0, 10)
        .map((item) => ({
          label: item.topic,
          value: item.count,
        })) || []
    );
  }
}
